const hideNavbar = (path) => {
  const hideNavbarList = [
    '/login',
    '/forgot-password',
    '/reset-password',
    '/forbidden-schedule',
    '/reschedule-form',
    '/host/help-request-form',
    '/host/detail',
    '/host/achievement-detail',
    '/host/upcoming',
    '/host/past',
    '/host/scheduled',
    '/host/attendance-record',
    '/host/task-submission',
    '/host/stream',
  ];

  return hideNavbarList.some((route) => path.startsWith(route));
};

export default hideNavbar;
